import { render, staticRenderFns } from "./TdcClinica.vue?vue&type=template&id=412272a7&scoped=true"
import script from "./TdcClinica.vue?vue&type=script&lang=js"
export * from "./TdcClinica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412272a7",
  null
  
)

export default component.exports